import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    color: theme.palette.primary.main,
  },
  heading: {
    width: "100%",
    fontSize: "0.875rem",
    fontWeight: 400,
    color: "#0A1A2F",
  },
  controls: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  mainControls: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
  },
  moreModelsButtonWrapper: {
    cursor: "pointer",
  },
  moreModelsButton: {
    padding: theme.spacing(2, 4),
    border: "2px solid #d2d2d7",
    borderRadius: "1.25rem",
    fontSize: "0.625rem",
    backgroundColor: "#f5f5f5",
    cursor: "not-allowed",
    opacity: 0.7,
    display: "flex",
    alignItems: "center",
    color: "#86868b",
    pointerEvents: "none",
  },
  additionalModels: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
  },
  toggleButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.75),
    padding: theme.spacing(3),
    marginTop: theme.spacing(2.5),
    backgroundColor: "white",
    color: theme.palette.primary.main,
    border: "2px solid #d2d2d7",
    borderRadius: "0.5rem",
    fontSize: "0.75rem",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s",

    "&:hover": {
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
      backgrondColor: "rgba(255, 58, 75, 0.05)",
    },
  },
  toggleButtonExpanded: {
    "& svg": {
      transform: "rotate(180deg)",
    },
  },
}));
